import { space } from '@/constants/tokens';
import { openURL } from '@/src/utils/linkingUtils';
import { Image } from 'expo-image';
import { Text, View, YStack } from 'tamagui';
import PSButton from './ui/PSButton';
import PSIcon from './ui/PSIcon';

// Source is 3334×1346 — trimmed to the wordmark's own bounds, so this ratio
// is what keeps it from letterboxing inside the Image.
const WORDMARK_ASPECT_RATIO = 3334 / 1346;
const WORDMARK_HEIGHT = 48;

export default function Footer() {
  return (
    <YStack
      alignItems="center"
      px={'$space.xxl'}
      pb={'$space.xxl'}
      mt={'$space.xxl'}
      mb={'$space.xxl'}
    >
      <View
        alignSelf="stretch"
        borderBottomWidth="$borderWidth.hairline"
        borderColor="$borderColor"
        my={'$space.xxl'}
      />

      <Text fontSize={'$xl'} textAlign={'center'} lineHeight={'$large'}>
        The best things hide in plain sight. We know{' '}
        <Text fontSize={'$xl'} color={'$color.brand'} lineHeight={'$large'}>
          where to look :)
        </Text>
      </Text>

      <YStack gap={'$space.lg'} mt={'$space.xl'}>
        <PSButton
          title="Find out first on WhatsApp"
          variant="outline"
          icon={<PSIcon name="logo-whatsapp" />}
          onPress={() => openURL('https://tap.puttingscene.com/Whatsapp')}
        />
        <PSButton
          title="Follow the scene on the 'gram"
          variant="outline"
          icon={<PSIcon name="logo-instagram" />}
          onPress={() => openURL('https://instagram.com/putting.scene')}
        />
      </YStack>

      <Image
        source={require('@/assets/images/puttingscene-wordmark.png')}
        style={{
          width: WORDMARK_HEIGHT * WORDMARK_ASPECT_RATIO,
          height: WORDMARK_HEIGHT,
          marginTop: space.xxl,
        }}
        contentFit="contain"
      />
    </YStack>
  );
}
